<div class="login-body">
  <p-toast key="top" position="top-center"></p-toast>
  <div class="login-panel">
    <div class="grid" [formGroup]="form">
      <div class="login-header">
        <img class="login-logo" [src]="app.getLogoLoginPngUrl()" />
        <h1>Registrierung</h1>
        <h2>{{app.appName}}</h2>
      </div>
      <div class="col-12">
        <input style="width:100%" type="text" autocomplete="off" class="p-inputtext p-component"
          placeholder="Benutzername" formControlName="userName">
      </div>
      <div class="col-12">
        <input style="width:100%" type="password" autocomplete="off" class="p-inputtext p-corner-all p-component"
          placeholder="Passwort" formControlName="password">
      </div>
      <div class="col-12">
        <input style="width:100%" type="password" autocomplete="off" class="p-inputtext p-corner-all p-component"
          placeholder="Passwort wiederholen" formControlName="passwordRepeat">
      </div>
      <div class="col-12">
        <p-button styleClass="width100p" icon="fas fa-sign-in" label="Registrieren" (onClick)="send()">
        </p-button>
        <a [routerLink]="['/base', 'login']">
          <p-button styleClass="width100p" icon="fas fa-lock" severity="secondary" label="Abbrechen" (onClick)="cancel()">
          </p-button>
        </a>
        @if (running) {
          <div>
            <div>Registrierung läuft ...</div>
            <p-progressSpinner></p-progressSpinner>
          </div>
        }
        @if (!running && done) {
          <p-message [severity]="resultType" styleClass="mr-2">{{resultMessage}}</p-message>
        }
      </div>
    </div>
  </div>
